import { UseMeResponse } from "@/hooks/use-me-query";

const selectIsGaveBirth = (data: UseMeResponse) => data.meta?.isGaveBirth === "yes";

export default selectIsGaveBirth;
